export default __webpack_public_path__ + "static/media/about-team-02.ffce84bc.jpg";